import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { DayAgoPipe } from 'libs/shared/src/lib/filters/dayago.pipe';
import { TimeLinePipe } from 'libs/shared/src/lib/filters/timeline.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'date-cell',
  templateUrl: './date-cell.component.html',
  styleUrls: ['./date-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DayAgoPipe,
    TooltipModule
]
})
export class DateCellComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null)
  constructor( private datePipe:DatePipe) { }
  ngOnInit(): void {}

  
  isEmptyAndNull(obj: any) {
    if (!obj)
      return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false
  }

  showDate(date:any)
  {
    return this.datePipe.transform(new Date(date), 'MMM dd yyyy hh:mm:ss a');
  }

  hasValue(obj: any) {
    if (obj != null && obj != undefined)
     return true;
    else return false
  }

}
